import * as types from "../actions/types/index";
import assets from "../util/assets";

const INITIAL_STATE = {
  showAvailabilityModal: false,
  showAwaitingModal: false,
  commonConfirmationFlag: false,
  showTipModalFlag: false,
  showTipResponseModalFlag: false,
  showTipListModalFlag: false,
  showCommonModal:false,
  commonModalPayload: {
    image: assets.awaiting_stopwatch,
    title: "Title",
    description: "Description",
    action: {
      text: "OK",
      click: () => {
      }
    }
  },
  isConfirmationModal: false,
  actionArray: [],
  showBroadcasterVideoPlayerModal:false,
  broadcasterVideoPlayerModalPayload: {
    video: null,
    action: {
      text: "OK",
      click: () => {
      }
    }
  },
};
export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case types.SHOW_REQUEST_AVAILABLE_BROADCAST_MODAL:
      return {
        ...state,
        showAvailabilityModal: true,
      };
    case types.HIDE_REQUEST_AVAILABLE_BROADCAST_MODAL:
      return {
        ...state,
        showAvailabilityModal: false,
      };
    case types.SHOW_AWAITING_MODAL:
      return {
        ...state,
        showAwaitingModal: true,
      };
    case types.HIDE_AWAITING_MODAL:
      return {
        ...state,
        showAwaitingModal: false,
      };
    case types.SHOW_COMMON_CONFIRMATION_MODAL:
      return {
        ...state,
        commonConfirmationFlag: true,
      };
    case types.HIDE_COMMON_CONFIRMATION_MODAL:
      return {
        ...state,
        commonConfirmationFlag: false,
      };
    case types.SHOW_TIP_MODAL:
      return {
        ...state,
        showTipModalFlag: true,
      };
    case types.HIDE_TIP_MODAL:

      return {
        ...state,
        showTipModalFlag: false,
      };
    case types.SHOW_TIP_RESPONSE_MODAL:

      return {
        ...state,
        showTipResponseModalFlag: true,
      };
    case types.HIDE_TIP_RESPONSE_MODAL:

      return {
        ...state,
        showTipResponseModalFlag: false,
      };
    case types.SHOW_TIP_LIST_MODAL:

      return {
        ...state,
        showTipListModalFlag: true,
      };
    case types.HIDE_TIP_LIST_MODAL:

      return {
        ...state,
        showTipListModalFlag: false,
      };
    case types.SHOW_COMMON_MODAL:
      return {
        ...state,
        showCommonModal: true,
        commonModalPayload:action.payload,
        isConfirmationModal:action.isConfirmationModal,
        actionArray:action.actionArray
      };
    case types.HIDE_COMMON_MODAL:
      return {
        ...state,
        showCommonModal: false,
        commonModalPayload:action.payload
      };
    case types.SHOW_BROADCASTER_VIDEO_PLAYER_MODAL:
      return {
        ...state,
        showBroadcasterVideoPlayerModal: true,
        broadcasterVideoPlayerModalPayload:action.payload
      };
    case types.HIDE_BROADCASTER_VIDEO_PLAYER_MODAL:
      return {
        ...state,
        showBroadcasterVideoPlayerModal: false,
        broadcasterVideoPlayerModalPayload:action.payload
      };
    default:
      return {
        ...state,
      };
  }
}
